import React, { useState } from 'react'

import FilterListIcon from '@mui/icons-material/FilterList'
import { Dialog, DialogContent, DialogTitle, IconButton, Toolbar, Tooltip, Typography } from '@mui/material'

type TableToolbarProps = {
  filter?: (...args: any[]) => any
  title?: string
  toolbar?: React.ReactNode
}

const TableToolbar = ({ filter, title, toolbar }: TableToolbarProps) => {
  const [filtersOpen, setFiltersOpen] = useState(false)

  const handleClose = () => setFiltersOpen(false)

  return (
    <Toolbar className="table__toolbar" sx={{ py: 1.5 }}>
      <Typography id="tableTitle" variant="h6">
        {title}
      </Typography>
      <div className="table__toolbar__actions">
        {toolbar}
        {!!filter && (
          <Tooltip title="Filter list">
            <IconButton aria-label="Filter list" onClick={() => setFiltersOpen(true)} size="large">
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <Dialog onClose={handleClose} open={filtersOpen}>
        <DialogTitle>Filters</DialogTitle>
        <DialogContent>{filter && React.createElement(filter, { onModalClose: handleClose })}</DialogContent>
      </Dialog>
    </Toolbar>
  )
}

export default TableToolbar
